var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wtw-container clearfix full policies-container" },
    [
      _c(
        "div",
        { staticClass: "policies-header" },
        [
          _c("h2", { staticClass: "policies-header-title" }, [
            _vm._v("Please read and agree to the following to use Mada")
          ]),
          _vm._v(" "),
          _c("checkbox", {
            staticClass: "policies-header-accept-all",
            attrs: {
              label: "Accept All",
              name: "accept_all",
              color: "checked",
              value: _vm.allAccepted
            },
            on: { input: _vm.acceptAll }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "policies-checkbox-container" },
        [
          _c(
            "checkbox",
            {
              attrs: { label: "Privacy Policy", name: "privacy_policy" },
              model: {
                value: _vm.accept["privacy-policy"],
                callback: function($$v) {
                  _vm.$set(_vm.accept, "privacy-policy", $$v)
                },
                expression: "accept['privacy-policy']"
              }
            },
            [
              _c("p", { staticClass: "policies-checkbox-secondary-label" }, [
                _vm._v(
                  "Mada and its affiliates are allowed to process my sensitive personal data to provide services."
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "policies-checkbox-link",
                  on: {
                    click: function($event) {
                      return _vm.open("privacy-policy")
                    }
                  }
                },
                [_vm._v("Learn more")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "checkbox",
            {
              attrs: {
                label: "End User License Agreement",
                name: "end_user_license"
              },
              model: {
                value: _vm.accept["end-user-license"],
                callback: function($$v) {
                  _vm.$set(_vm.accept, "end-user-license", $$v)
                },
                expression: "accept['end-user-license']"
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "policies-checkbox-link",
                  on: {
                    click: function($event) {
                      return _vm.open("end-user-license")
                    }
                  }
                },
                [_vm._v("Learn more")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "checkbox",
            {
              attrs: { label: "Terms of Use", name: "terms_of_use" },
              model: {
                value: _vm.accept["terms-of-use"],
                callback: function($$v) {
                  _vm.$set(_vm.accept, "terms-of-use", $$v)
                },
                expression: "accept['terms-of-use']"
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "policies-checkbox-link",
                  on: {
                    click: function($event) {
                      return _vm.open("terms-of-use")
                    }
                  }
                },
                [_vm._v("Learn more")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("agreement-modal", {
        attrs: {
          show: _vm.showAgreementModal,
          loading: _vm.loadingAgreement,
          content: _vm.modalAgreementHtmlContent
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-086cd0a5", { render: render, staticRenderFns: staticRenderFns })
  }
}